import { z } from 'zod';
import { Validation } from '@mews/framework';
import { ReservationState } from '@mews-commander/data-access';
import { FiltersDateValueKey } from '../common/filters/dateSchema';

export enum FiltersValueKey {
    ownerTypes = 'ownerTypes',
    associatedAccountTypes = 'associatedAccountTypes',
    reservationLinkStates = 'reservationLinkStates',
    reservationStates = 'reservationStates',
    arrivalStart = 'arrivalStart',
    arrivalEnd = 'arrivalEnd',
    balanceMin = 'balanceMin',
    balanceMax = 'balanceMax',
}

export const filtersSchema = z.object({
    [FiltersValueKey.ownerTypes]: z.array(z.string()).optional(),
    [FiltersValueKey.associatedAccountTypes]: z.array(z.string()).optional(),
    [FiltersValueKey.reservationStates]: z.array(z.nativeEnum(ReservationState)).optional(),
    [FiltersValueKey.arrivalStart]: z.string().optional(),
    [FiltersValueKey.arrivalEnd]: z.string().optional(),
    [FiltersValueKey.balanceMin]: z.union([z.coerce.number(), z.literal('')]).optional(),
    [FiltersValueKey.balanceMax]: z.union([z.coerce.number(), z.literal('')]).optional(),
});

export const urlSchema = z
    .object({
        filterValues: filtersSchema.optional(),
        [FiltersDateValueKey.date]: Validation.Date.Iso.optional(),
    })
    .partial();

export type DepositLedgerFilterValues = z.infer<typeof filtersSchema>;
